export default __webpack_public_path__ + "static/media/personal-invoice-icon.aac26c85.svg";